import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';

import { Observable, forkJoin, of } from 'rxjs';
import { concatMap, tap } from 'rxjs/operators';
import * as moment from 'moment-timezone';
import { AuthService } from '../../../../@core/auth/auth.service';
import { FarmFeature, FarmFeatureType, FarmFeatureTypeThreshold } from '../models/farm-feature-dto';
import { environment } from '../../../../../environments/environment';
import { FarmFeatureEvent, FarmFeatureEventType, FarmFeatureEventTypeAttribute, FarmFeatureEventTypeAttributeOption } from '../models/farm-feature-event';
import { FarmFeatureEventTimelineItem } from '../models/farm-feature-event-timeline-item';

@Injectable({
  providedIn: 'root'
})
export class FarmFeatureService {

  constructor(
    private authService: AuthService,
    protected httpClient: HttpClient,
  ) {

  }


  /**** FARM FEATURE BY ID  ****/
  public getFarmFeatureById(id: number): Observable<any> {
    return this.httpClient.get(`${environment.PLATFORM_API_URL}/api/farmfeatures/${id}`);
  }

  /**** FARM FEATURE TYPES  ****/
  public getFarmFeatureTypes(observe?: 'body', reportProgress?: boolean): Observable<Array<FarmFeatureType>>;
  public getFarmFeatureTypes(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<FarmFeatureType>>>;
  public getFarmFeatureTypes(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<FarmFeatureType>>>;
  public getFarmFeatureTypes(observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    return this.httpClient.get(`${environment.PLATFORM_API_URL}/api/farmfeaturetypes`);
  }

  public getFarmFeatureType(id: number, observe?: 'body', reportProgress?: boolean): Observable<FarmFeatureType>;
  public getFarmFeatureType(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<FarmFeatureType>>;
  public getFarmFeatureType(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<FarmFeatureType>>;
  public getFarmFeatureType(id: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    return this.httpClient.get(`${environment.PLATFORM_API_URL}/api/farmfeaturetypes/${id}`);
  }

  public getLoadingAreas(): Observable<any> {
    return this.httpClient.get(`${environment.PLATFORM_API_URL}/api/farmfeaturetypes/LoadingAreas`);
  }

  public addOrUpdateFarmFeatureType(featureType: FarmFeatureType, observe?: 'body', reportProgress?: boolean): Observable<any>;
  public addOrUpdateFarmFeatureType(featureType: FarmFeatureType, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
  public addOrUpdateFarmFeatureType(featureType: FarmFeatureType, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
  public addOrUpdateFarmFeatureType(featureType: FarmFeatureType, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


    if (featureType.farmFeatureTypeId == 0) {
      return this.httpClient.post(`${environment.PLATFORM_API_URL}/api/farmfeaturetypes`, featureType,
        {
          observe: observe,
          reportProgress: reportProgress
        }
      );
    } else {
      return this.httpClient.put(`${environment.PLATFORM_API_URL}/api/farmfeaturetypes/${featureType.farmFeatureTypeId}`, featureType,
        {
          // withCredentials: this.configuration.withCredentials,
          observe: observe,
          reportProgress: reportProgress
        }
      );
    }

  }

  /*** Farm Features/EVENTS */


  public getFarmFeatureEvents(cropYear?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<FarmFeatureEvent>>;
  public getFarmFeatureEvents(cropYear?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<FarmFeatureEvent>>>;
  public getFarmFeatureEvents(cropYear?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<FarmFeatureEvent>>>;
  public getFarmFeatureEvents(cropYear?: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    let queryParameters = new HttpParams();

    if (cropYear)
      queryParameters = queryParameters.append('cropYear', cropYear.toString());

    return this.httpClient.get(`${environment.PLATFORM_API_URL}/api/farmfeaturesevent`,
      {
        params: queryParameters
      }
    );
  }

  /*** Farm Features/EVENTS/{id} */


  // public getFarmFeatureEventsById(cropYear?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<FarmFeatureEvent>>;
  // public getFarmFeatureEventsById(cropYear?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<FarmFeatureEvent>>>;
  // public getFarmFeatureEventsById(cropYear?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<FarmFeatureEvent>>>;
  public getFarmFeatureEventsByFeatureId(id: number, cropYear?: number): Observable<any> {

    let queryParameters = new HttpParams();

    if (cropYear)
      queryParameters = queryParameters.append('cropYear', cropYear.toString());

    return this.httpClient.get(`${environment.PLATFORM_API_URL}/api/farmfeaturesevent/ByFeatureId/${id}`,
      {
        params: queryParameters
      }
    );
  }




  /*** Farm Features Event Types */
  public getFarmFeatureEventTypes(observe?: 'body', reportProgress?: boolean): Observable<Array<FarmFeatureEventType>>;
  public getFarmFeatureEventTypes(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<FarmFeatureEventType>>>;
  public getFarmFeatureEventTypes(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<FarmFeatureEventType>>>;
  public getFarmFeatureEventTypes(observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    let queryParameters = new HttpParams();

    return this.httpClient.get(`${environment.PLATFORM_API_URL}/api/farmfeatureseventtype`,
      {
        params: queryParameters
      }
    );
  }

  public updateFarmEventAttributes(id: number, attributes: FarmFeatureEventTypeAttribute[]): Observable<any> {
  return this.httpClient.put(
    `${environment.PLATFORM_API_URL}/api/farmfeatureseventtype/farm-event-attribute/${id}`,
    attributes
  );
  }
  public deleteFarmEventAttribute(id: number): Observable<any> {
    return this.httpClient.delete(
      `${environment.PLATFORM_API_URL}/api/farmfeatureseventtype/farm-event-attribute/${id}`
    );
  }
  public getFarmEventAttributes(farmFeatureEventTypeId: number): Observable<FarmFeatureEventTypeAttribute[]> {
    return this.httpClient.get<FarmFeatureEventTypeAttribute[]>(
      `${environment.PLATFORM_API_URL}/api/farmfeatureseventtype/farm-event-attribute/${farmFeatureEventTypeId}`
    );
  }
  public deleteFarmEventAttributeOptions(ids: number[]) {
    return this.httpClient.post(
      `${environment.PLATFORM_API_URL}/api/farmfeatureseventtype/delete-attribute-options`,
      ids
    );
  }

    public deleteThresholds(thresholdIds: number[]) {
    return this.httpClient.post(
      `${environment.PLATFORM_API_URL}/api/farmfeatureseventtype/delete-thresholds`,
      thresholdIds
    );
  }

  // Single authoritative pipeline for persisting an Event Type's attribute edits: deletes
  // removed options/thresholds/attributes, then bulk-upserts the remaining attribute list.
  // Shared by the standalone attribute dialog and the unified Asset Type create/edit dialog.
  public saveEventTypeAttributes(
    eventTypeId: number,
    gridDataSource: FarmFeatureEventTypeAttribute[],
    deletedAttributes: FarmFeatureEventTypeAttribute[],
    deletedOptions: FarmFeatureEventTypeAttributeOption[],
    deletedThresholds: FarmFeatureTypeThreshold[]
  ): Observable<any> {
    const optionIds = Array.from(new Set(
      (deletedOptions || []).filter(x => x.id && x.id > 0).map(x => x.id)
    ));

    const thresholdIds = Array.from(new Set(
      (deletedThresholds || []).filter(x => x.id && x.id > 0).map(x => x.id)
    ));

    const deleteOptionsCalls$ = optionIds.length
      ? this.deleteFarmEventAttributeOptions(optionIds) : of(null);

    const deleteThresholdCalls$ = thresholdIds.length
      ? this.deleteThresholds(thresholdIds) : of(null);

    const mergedDeleteAttributeCalls = (deletedAttributes || []).map(x =>
      this.deleteFarmEventAttribute(x.id)
    );

    const deleteAttributeCalls$ = mergedDeleteAttributeCalls.length
      ? forkJoin(mergedDeleteAttributeCalls) : of(null);

    return deleteOptionsCalls$.pipe(
      concatMap(() => deleteThresholdCalls$),
      concatMap(() => deleteAttributeCalls$),
      concatMap(() => this.updateFarmEventAttributes(eventTypeId, gridDataSource))
    );
  }


  public getFarmFeatures(eventStartDate?: Date, eventEndDate?: Date, blockId?: number, farmId?: number): Observable<FarmFeature[]> {

    let queryParameters = new HttpParams();

    if (blockId)
      queryParameters = queryParameters.append('blockId', blockId.toString());

    if (farmId)
      queryParameters = queryParameters.append('farmId', farmId.toString());

    if (eventStartDate)
      queryParameters = queryParameters.append('eventStartDate', moment(eventStartDate).toISOString());


    if (eventEndDate)
      queryParameters = queryParameters.append('eventEndDate', moment(eventEndDate).toISOString());
    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];

    return this.httpClient.get<FarmFeature[]>(`${environment.PLATFORM_API_URL}/api/farmfeatures`,
      {
        params: queryParameters
      }
    );
  }

  public putFarmFeature(feature: FarmFeature): Observable<FarmFeature> {
    return this.httpClient.put<FarmFeature>(`${environment.PLATFORM_API_URL}/api/farmfeatures/${feature.farmFeatureId}`, feature);
  }

  public postFarmFeature(feature: FarmFeature): Observable<FarmFeature> {
    return this.httpClient.post<FarmFeature>(`${environment.PLATFORM_API_URL}/api/farmfeatures`,
      feature);
  }

  // Fetch Delet Api 
  public deleteFarmFeature(feature: FarmFeature): Observable<void> {
    return this.httpClient.delete<void>(`${environment.PLATFORM_API_URL}/api/farmfeatures/${feature.farmFeatureId}`);
  }


  /// REPORTS

  public getEventTimelineReport(cropYear: number, farmId: number = 0, includeEvents = true, startDate: Date = null, endDate: Date = null
    , groupType: string = "week"): Observable<FarmFeatureEventTimelineItem[]> {

    let queryParameters = new HttpParams();

    queryParameters = queryParameters.append("cropYear", cropYear.toString());
    queryParameters = queryParameters.append("dateType", groupType);


    if (farmId > 0)
      queryParameters = queryParameters.append("farmId", farmId.toString());

    if (!includeEvents)
      queryParameters = queryParameters.append("includeEvents", "false");

    if (startDate)
      queryParameters = queryParameters.append("startDate", moment(startDate).toISOString());

    if (endDate)
      queryParameters = queryParameters.append("endDate", moment(endDate).toISOString());

    return this.httpClient.get<FarmFeatureEventTimelineItem[]>(`${environment.PLATFORM_API_URL}/api/farmfeaturesevent/reports/timeline`,
      {
        params: queryParameters
      }
    );
  }

  public getEventTimelineReportById(id: number, cropYear: number): Observable<FarmFeatureEventTimelineItem[]> {

    let queryParameters = new HttpParams();

    queryParameters = queryParameters.append("cropYear", cropYear.toString());
    queryParameters = queryParameters.append("dateType", "week");

    return this.httpClient.get<FarmFeatureEventTimelineItem[]>(`${environment.PLATFORM_API_URL}/api/farmfeaturesevent/reports/timeline/${id}`,
      {
        params: queryParameters
      }
    );
  }

  public sendTimelineReportEmail(emailObject: any) {
    let queryParameters = new HttpParams();

    return this.httpClient.post<FarmFeatureEventTimelineItem[]>(`${environment.PLATFORM_API_URL}/api/farmfeaturesevent/reports/email`, emailObject,
      {
        params: queryParameters
      }
    );
  }




  public putFarmFeatureEvent(event: FarmFeatureEvent): Observable<FarmFeatureEvent> {
    return this.httpClient.put<FarmFeatureEvent>(`${environment.PLATFORM_API_URL}/api/FarmFeaturesEvent/${event.id}`, event);
  }


  public postFarmFeatureEvent(event: FarmFeatureEvent): Observable<FarmFeatureEvent> {

    if (environment.isMockEnabled) {
      return of(event);
    }

    return this.httpClient.post<FarmFeatureEvent>(`${environment.PLATFORM_API_URL}/api/FarmFeaturesEvent`,
      event);
  }

  public deleteFarmFeatureEvent(id: number): Observable<FarmFeatureEvent> {
    let queryParameters = new HttpParams();
    queryParameters = queryParameters.set('setInactive', "false");

    return this.httpClient.delete<FarmFeatureEvent>(`${environment.PLATFORM_API_URL}/api/FarmFeaturesEvent/${id}`,
      {
        params: queryParameters,
      }
    );
  }


  public getFarmFeatureEvent(id: number): Observable<FarmFeatureEvent> {

    let queryParameters = new HttpParams();
    queryParameters = queryParameters.set('setInactive', "false");

    return this.httpClient.get<FarmFeatureEvent>(`${environment.PLATFORM_API_URL}/api/FarmFeaturesEvent/${id}`,
      {
        params: queryParameters,
      }
    );
  }

  //Save Event Type
  public postFarmFeatureEventType(featureEventType: FarmFeatureEventType): Observable<FarmFeatureEventType> {
    return this.httpClient.post<FarmFeatureEventType>(`${environment.PLATFORM_API_URL}/api/farmfeatureseventtype`,
      featureEventType);
  }

  //Update Event Type
  public putFarmFeatureEventType(featureEventType: FarmFeatureEventType): Observable<FarmFeatureEventType> {
    return this.httpClient.put<FarmFeatureEventType>(`${environment.PLATFORM_API_URL}/api/farmfeatureseventtype/${featureEventType.id}`,
      featureEventType
    );
  }

}

